export default __webpack_public_path__ + "static/media/m2.5d9866e2.jpg";